import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
import type { ChaletDayAvailability } from '@/lib/types';

// GET /services/chalet-availability/:id?month=YYYY-MM
// Returns one entry per day in that month with availability info.
export function useChaletAvailability(serviceId: string | undefined, month: string | undefined) {
  return useQuery({
    queryKey: ['/services/chalet-availability', serviceId, month],
    queryFn: async (): Promise<ChaletDayAvailability[]> => {
      const response = await apiClient.get(
        `/services/chalet-availability/${serviceId}?month=${month}`
      );
      if (!response.ok) {
        throw new Error('Failed to fetch chalet availability');
      }
      return response.json();
    },
    enabled: !!serviceId && !!month,
    staleTime: 0,
    gcTime: 0,
  });
}
